// icon
import { IconUser, IconHeart, IconCategory } from "@tabler/icons-react";
// components
import Profile from "../../pages/admin/profile/profile";
import WishList from "../../pages/admin/wishList/wishlist";
import ProfileEdit from "../../pages/admin/profileEdit/profileEdit";

export const RoutesUser = [
    {
        show: true,
        child: false,
        label: 'داشبورد',
        address: '/user/profile',
        component: <Profile />,
        icon: <IconCategory />,
    },
    {
        show: true,
        child: false,
        label: 'اطلاعات کاربری',
        address: '/user/detail',
        component: <ProfileEdit />,
        icon: <IconUser />,
    },
    {
        show: true,
        child: false,
        label: 'علاقه مندی ها',
        address: '/user/wishList',
        component: <WishList />,
        icon: <IconHeart />,
    },

]